import styled from 'styled-components';

export const Notice = styled.div `
    margin: 0;
    
    color: #3B2F1E;
    min-height: 100dvh;
    padding: 24px;

    * { box-sizing: border-box; }

    .alert{
      width: min(800px, 100%);
      border: 1.5px solid #F6C453;
      background: #FFF8E6;
      border-radius: 16px;
      box-shadow: 0 8px 20px rgba(0,0,0,.08);
      padding: 18px 20px 16px;
      line-height: 1.5;
    }

    .alert__header{
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 8px;
      font-weight: 800;
      letter-spacing: .02em;
      color: #B45309;
      text-transform: uppercase;
    }

    .alert__icon{
      flex: 0 0 auto;
      width: 22px;
      height: 22px;
      display: inline-grid;
      place-items: center;
    }

    .alert__body{
      margin: 0;
      font-size: var(--font-size-scale-base);
      text-align: justify;
    }

    /* Borda lateral de destaque (opcional, puramente decorativa) */
    .alert{
      position: relative;
      overflow: clip;
    }
    .alert::before{
      content: "";
      position: absolute;
      inset: 0 auto 0 0;
      width: 6px;
      background: linear-gradient(180deg, #F6C453, color-mix(in oklab, #B45309 60%, transparent));
    }
`;